import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgsPaginatorComponent } from './pgs-paginator.component';
import { PgsPaginatorPipe } from './pgs-paginator.pipe';
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
  declarations: [ PgsPaginatorComponent, PgsPaginatorPipe ],
  imports: [ CommonModule, NgSelectModule ],
  exports: [ PgsPaginatorComponent, PgsPaginatorPipe ]
})
export class PgsPaginatorModule { }
